import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-listing-content.css.lit';

import { OutlineElement } from '../../../base/outline-element/outline-element';
import { SlotController } from '../../../controllers/slot-controller';

/**
 * Listing Content Component
 * @element ghs-listing-content
 */
@customElement('ghs-listing-content')
export class GhsListingContent extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html`
      <div class="listing-content">
        <slot></slot>
      </div>
    `;
  }
}
